// @flow

import CardInsurance from './CardInsurance'

export default CardInsurance
